import "./menu.js";
import "./cards.js";
import "./mail.js";
import "./bar-chart.js";

window.addEventListener("scroll", hasScrolledTop);
window.addEventListener("DOMContentLoaded", hasScrolledTop);

function hasScrolledTop() {
  document.body.classList.toggle("scrollTop", window.scrollY === 0);
}

window.addEventListener("DOMContentLoaded", () => {
  // lazy load javascript for the quiz – it's huge because of the dependency of react
  document.querySelectorAll(".quiz").forEach((el) => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            import("./quiz/index.tsx").then(({ initQuiz }) => {
              initQuiz(el);
            });
            observer.unobserve(el);
          }
        });
      },
      { rootMargin: "1000px 0px 1000px 0px" }
    );
    observer.observe(el);
  });

  // save visted state of section buttons in local state
  document.querySelectorAll(".section-button").forEach((el) => {
    const currentHref = el.getAttribute("href");
    const localStorageSource = localStorage.getItem("visitedModules");
    const visitedModules = localStorage.getItem("visitedModules")
      ? JSON.parse(localStorageSource)
      : [];

    if (
      el.classList.contains("active") &&
      visitedModules.indexOf(currentHref) === -1
    ) {
      visitedModules.push(currentHref);
      localStorage.setItem("visitedModules", JSON.stringify(visitedModules));
    }

    el.classList.toggle("visited", visitedModules.includes(currentHref));
  });

  const contentEl = document.getElementById("content");
  if (contentEl.style.getPropertyValue("--accent-color").includes("blue")) {
    contentEl.style.setProperty("--text-on-accent-color", "var(--white)");
    contentEl.classList.add("accent-background-dark");
    contentEl.style.setProperty("--grey", "var(--grey-blue)");
  }
  if (contentEl.style.getPropertyValue("--accent-color").includes("green")) {
    contentEl.style.setProperty("--grey", "var(--grey-green)");
  }

  const maileonCaptchaFormField = document.querySelectorAll(
    "#maileon_contact_form_captcha"
  );
  maileonCaptchaFormField.forEach((el) => {
    el.setAttribute("aria-label", "Captcha-Ergebnis");
  });
});
